import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "shared/ui-basics";
import { useModal } from "use-modal-hook";

type Props = {
	modal: any;
	closeDropdown?: () => void;
	selected: any;
	link?: (id: string, e?: any) => void;
	onCreate?: any;
};

function RenderAdvancedModalFooter({ modal, closeDropdown, selected, link, onCreate }: Props): JSX.Element {
	const [advancedSearchModal] = useModal(modal);
	const { t } = useTranslation();

	return (
		<div className="footer-typehead-generic">
			<Button
				size="s"
				variant="dark-outline"
				onClick={() => {
					if (closeDropdown) closeDropdown();
					advancedSearchModal({ link, onCreate, selectedSolutionIds: selected });
				}}>
				{t("ADVANCED_SEARCH")}
			</Button>
		</div>
	);
}

export default RenderAdvancedModalFooter;
